module.exports = __webpack_public_path__ + "media/assets/icon-globe-dark-a5418aa6eb7a0551714cb2a1b841870d.svg";